import React, { memo } from 'react';
import { Button } from 'antd';
import { useBundle } from '@amzn/react-arb-tools';
import { safeGetMessage } from '@xbcb/ui-utils';
import { StyledHtsAlert, PromptMessageWrapper, PromptText } from './styles';

export interface HtsQuestionsPromptProps {
  onOpenDrawer: () => void;
}

export const HtsQuestionsPrompt: React.FC<HtsQuestionsPromptProps> = ({
  onOpenDrawer,
}) => {
  const [bundle] = useBundle('components.HtsClassification');

  return (
    <StyledHtsAlert
      type="warning"
      showIcon
      message={
        <PromptMessageWrapper>
          <PromptText>
            {safeGetMessage(bundle, 'hts_classification_prompt')}
          </PromptText>
          <Button type="primary" onClick={onOpenDrawer}>
            {safeGetMessage(bundle, 'hts_classify_button')}
          </Button>
        </PromptMessageWrapper>
      }
    />
  );
};

export default memo(HtsQuestionsPrompt);
